var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-row', {
    staticClass: "h-100",
    attrs: {
      "align-v": "top"
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "12",
      "lg": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "location-name",
      "placeholder": _vm.$t(`${_vm.type}.new-${_vm.type}-name`),
      "state": !_vm.$v.formData.name.$error ? null : false
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.name.alreadyAdded ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t(`already-exist.${_vm.type}-in-event`)) + " ")]) : _vm._e(), !_vm.$v.formData.name.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t(`${_vm.type}.new-${_vm.type}-name`),
          max: _vm.$v.formData.name.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.name.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.name, "$model", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "$v.formData.name.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": ""
    }
  }, [!_vm.colorPicker ? _c('form-selector', {
    staticClass: "selector",
    attrs: {
      "id": "location-order",
      "options": _vm.getOptionsPlusOne
    },
    model: {
      value: _vm.formData.order,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "order", $$v);
      },
      expression: "formData.order"
    }
  }) : _c('color-picker', {
    staticClass: "picker",
    attrs: {
      "placeholder": _vm.$t('choose-color')
    },
    model: {
      value: _vm.formData.color,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "color", $$v);
      },
      expression: "formData.color"
    }
  })], 1), _c('b-col', {
    staticClass: "ml-auto",
    attrs: {
      "md": "12",
      "lg": "auto"
    }
  }, [_c('b-button', {
    staticClass: "add-button",
    attrs: {
      "variant": "primary",
      "disabled": _vm.$v.formData.name.$error || _vm.formData.name === ''
    },
    on: {
      "click": function ($event) {
        return _vm.onAdd();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/master-data/save-white.svg")
    }
  })])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }